const NotificationService = {

  async manageNotification (obj, request, callback) {
    try {
      var response = await request
      if (response.data) {
        callback(response.data)
      } else if (response.errors) {
        if (obj) { obj.$refs.navigationlayout.setErrorNotification(response.errors) }
      } else {
        if (obj) { obj.$refs.navigationlayout.setErrorNotification([{errorMessage: 'Something goes wrong!'}]) }
      }
    } catch (err) {
      if (obj) { obj.$refs.navigationlayout.setErrorNotification([{errorMessage: err.message}]) }
    }
  }
}

export default NotificationService
